"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opcionesVentaRolDefecto = void 0;
exports.opcionesVentaRolDefecto = {
    monedasHabilitadas: ["pesos", "dolares"],
    clienteDefecto: "nuevo",
    monedaDefecto: "pesos",
    verRespuestaComercialCFE: false,
    comprobantesCuentaTerceros: false,
    controlarCaja: false,
    periodoDesdeHasta: false,
    modificarCotizacion: false,
    campoOrdenCompra: false,
    descuentos: true,
    descripcionLarga: false,
    modificarListaPrecio: "no",
    redondear: ["pesos"],
    facturarRemitos: false,
    lineaManual: true,
    notasDebitoParciales: false,
    emitirContado: true,
    emitirCredito: true,
    modificarFecha: true,
    fechaDefecto: "hoy",
    fechaDefectoDevoluciones: "hoy",
    comprobanteDefecto: "contado",
    usarVencimiento: false,
    mostrarPrecios: "sinIVA",
    cambioInformacionPersonalB16: false,
    modalidadVenta: false,
    montoRetenido: false,
    modificarIVA: true,
    autoEscribirConcepto: false,
    listaPrecioProductos: "",
    listaPrecioServicios: "",
    invertirOrdenAgregarItems: false,
    // Impresion
    modificarVistaImpresion: false,
    autoImpresionReciboElectronico: false,
    autoImpresion: false,
    impresionForzarDescarga: false,
    imprimirA4: true,
    imprimirIngles: false,
    imprimirTicket: false,
    impresionEFactura: "a4",
    impresionETicket: "a4",
    imprimirPrecioConSinDescuento: false,
    imprimirImporteConSinDescuento: false,
    facturarCantidadNegativa: false
};
